import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  id: "certify"
};
const _hoisted_2 = {
  id: "bgslide",
  class: "swiper-contaniner bgslide"
};
const _hoisted_3 = {
  class: "swiper-wrapper"
};
const _hoisted_4 = {
  class: "swiper-slide"
};
const _hoisted_5 = {
  class: "bgbox"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "txtname"
};
const _hoisted_11 = {
  class: "txtdesc"
};
const _hoisted_12 = {
  class: "swiper-wrapper"
};
const _hoisted_13 = {
  class: "swiper-slide"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "swiper-button-next"
};
const _hoisted_16 = {
  class: "swiper-button-prev"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`treasureList ${$data.isPc ? 'isPc' : ''}`)
  }, [_createElementVNode("div", _hoisted_1, [$data.isPc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "pcTitle",
    style: _normalizeStyle(`transform: scale(${$data.scale});top:${$data.pcTitleTop}px`)
  }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      alt: "",
      class: "swiper-lazy",
      src: item.itemformdata[3]
    }, null, 8, _hoisted_6)]), _createElementVNode("div", {
      class: "slideimg",
      onClick: $event => $options.openUrl(item.itemformdata[6]),
      style: _normalizeStyle(`transform: scale(${$data.scale})`)
    }, [_createElementVNode("img", {
      alt: "",
      class: "swiper-lazy",
      src: item.itemformdata[3]
    }, null, 8, _hoisted_8)], 12, _hoisted_7), _createElementVNode("div", {
      class: "slidetxt",
      onClick: $event => $options.openUrl(item.itemformdata[6]),
      style: _normalizeStyle(`transform: scale(${$data.scale})`)
    }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString(item.itemformdata[2]), 1)]), _createElementVNode("h2", null, [_cache[0] || (_cache[0] = _createElementVNode("span", null, null, -1)), _createTextVNode(_toDisplayString(item.itemformdata[1]), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("h3", null, [_createElementVNode("span", null, _toDisplayString(item.itemformdata[4]), 1)]), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(item.itemformdata[5]), 1)])])], 12, _hoisted_9)]);
  }), 256))])]), _withDirectives(_createElementVNode("div", {
    id: "bottomslide",
    class: "swiper-container bottomslide",
    style: _normalizeStyle(`transform: scale(${$data.scale});bottom:${$data.showBottom ? '30px' : '-100px'}`)
  }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    id: "canvasdiv"
  }, null, -1)), _cache[2] || (_cache[2] = _createElementVNode("canvas", {
    id: "canvas"
  }, null, -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("img", {
      src: item.itemformdata[3],
      class: "swiper-lazy"
    }, null, 8, _hoisted_14)]);
  }), 256))]), _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [[_vShow, $data.isPc]]), _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [[_vShow, $data.isPc]])], 4), [[_vShow, $data.onLoad]])])], 2);
}